import React from 'react';
import Loading from 'components/pure/utils/Loading';
import HelpLink from 'components/pure/admin/HelpLink';
import Button from '@material-ui/core/Button';
import TeamCounts from './TeamCounts';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DepartmentTeams from './DepartmentTeams';
import CreateDepartmentDialog from './CreateDepartmentDialog';
import TeamMoveDialog from './TeamMoveDialog';
import 'styles/admin/TeamsPage.styl';
import {AdminTeamDialog} from 'components/pure/admin/AdminTeamDialog';

export default class TeamsPage extends React.PureComponent {
  state = {
    teamDialogOpen: false,
    editTeam: null,
  };

  activeUserSum(teams) {
    return teams ? teams.reduce((sum, team) => (team.usersCount || 0) + sum, 0) : null;
  }

  render() {
    const {TeamListStore, DepartmentStore, DepartmentFormStore, TeamActions} = this.props;
    const {departmentProfiles} = DepartmentStore;
    const allTeams = TeamListStore.departmentTeams
      .toList()
      .flatten(true)
      .filter(t => !!t);

    const teamsLoading =
      DepartmentStore.areDepartmentProfilesLoading ||
      departmentProfiles.some(({id}) => TeamListStore.departmentTeamsLoading.get(id));

    return (
      <div className="teams-page">
        <h1>Manage Teams</h1>
        <HelpLink>
          <p>Drag and drop a team to move it to a different department.</p>
          <p>Click a team to manage it.</p>
          <p>Click on the user count to manage users in that team or department.</p>
        </HelpLink>
        <TeamCounts
          departmentCount={departmentProfiles.size}
          teamCount={allTeams.size}
          userCount={teamsLoading ? 'Loading...' : this.activeUserSum(allTeams)}
        />
        <p>
          In Coach, your teams are grouped into departments. Teams within a department share the
          same customization profiles (fields, archiving, scorecards, and keywords).
        </p>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={() => this.setState({teamDialogOpen: true, editTeam: null})}>
            New Team
          </Button>
          <Button
            variant="outlined"
            className="ev-button"
            onClick={this.props.DepartmentFormActions.openCreateDialog}>
            New Department
          </Button>
        </div>
        {DepartmentStore.wasDepartmentProfilesFetchError ? (
          'Error fetching departments for teams.'
        ) : teamsLoading ? (
          <Loading />
        ) : (
          <div>
            {departmentProfiles.map(department => (
              <DepartmentTeams
                key={department.id}
                showTeamDialog={team =>
                  this.setState({
                    editTeam: team,
                    teamDialogOpen: true,
                  })
                }
                TeamListStore={TeamListStore}
                TeamActions={TeamActions}
                department={department}
                departmentProfiles={departmentProfiles}
                TeamMoveDialogActions={this.props.TeamMoveDialogActions}
              />
            ))}
          </div>
        )}
        {TeamListStore.teamStagedForMove ? (
          <div>
            <div className="overlay" />
            <div className="drag-help">
              <HelpOutlineIcon />
              Drag team to another department to move them.
            </div>
          </div>
        ) : null}
        {this.state.teamDialogOpen && (
          <AdminTeamDialog
            users={this.props.UserStore.users}
            departments={departmentProfiles}
            team={this.state.editTeam}
            onClose={() =>
              this.setState({
                teamDialogOpen: false,
              })
            }
          />
        )}
        {DepartmentFormStore.isCreateDialogOpen && (
          <CreateDepartmentDialog
            errors={DepartmentFormStore.errors}
            touchedFields={DepartmentFormStore.touchedFields}
            wasSubmitRequested={DepartmentFormStore.wasSubmitRequested}
            department={DepartmentFormStore.department}
            isDepartmentSaving={DepartmentFormStore.isDepartmentSaving}
            {...this.props.DepartmentFormActions}
            {...this.props.DepartmentActions}
          />
        )}
        <TeamMoveDialog
          isTeamSaving={TeamListStore.isTeamSaving}
          open={!!this.props.TeamMoveDialogStore.team}
          departments={departmentProfiles}
          team={this.props.TeamMoveDialogStore.team}
          onRequestClose={() => this.props.TeamMoveDialogActions.openForTeam(null)}
          stageDepartmentToReceive={this.props.TeamMoveDialogActions.stageDepartmentToReceive}
          updateTeam={this.props.TeamActions.updateTeam}
        />
      </div>
    );
  }
}
